import React, { Component } from 'react';
import Lightbox from 'react-image-lightbox';

export default class TeamItem extends Component {
	constructor(props) {
		super(props);
		this.state = {
		  photoIndex: 0,
		  isOpen: false
		};
	}
	render() {
		const { isOpen } = this.state;
		return (
			<div className="grid-item" onClick={() => this.setState({ isOpen: true })}>
				<div
					className="grid-item__img swiper-lazy"
					data-background={this.props.image}>
					<div className="swiper-lazy-preloader" />
				</div>

				{this.props.title && (
					<div className="grid-item__title mt10">{this.props.title}</div>
				)}
				{this.props.subtitle && (
					<div className="grid-item__subtitle mt10">{this.props.subtitle}</div>
				)}
				{isOpen && (
		          <Lightbox
		            mainSrc={this.props.imageHq}
		            onCloseRequest={() => this.setState({ isOpen: false })}
		          />
		        )}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/TeamGrid/TeamItem.jsx